import { makeStyles } from '@material-ui/core/styles'

const styles = () => ({
  field: {
    border: 'none',
  },
  promo: {
    flexGrow: 1,
    padding: '5px 20px',
    border: '1px solid',
    borderColor: '#e2e2e2',
    borderRadius: '10px',
    backgroundColor: 'white',
  },
  error: {
    borderColor: '#C60000',
  },
  errorText: {
    color: '#C60000',
    fontWeight: 400,
  },
})

export default makeStyles(styles)
